


























































































































































































import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import PrettyCheck from 'pretty-checkbox-vue/check';
import { useFormat, useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import useEcho from '@/useEcho';
import vote from '@/table/vote';

import {
  getLive,
  getVote,
  getVotes,
  deleteVote,
  controlVote,
  deleteVotes,

  getVoteAsCSV,
} from '@/api';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithVoteDisplay from '@/components/Live/CommonModalWithVoteDisplay.vue';

const List = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonModalWithVoteDisplay,
  },
  setup() {
    const { pusher } = useEcho();
    const { route, routerPersist, router } = useRouter(['searchString', 'searchStatus']);
    const activePollId = ref(-1);
    const loading = ref(true);
    const votes = ref([]);
    const activePoll: Ref<any> = ref({
      id: -1,
      choices: [],
    });
    const pagination = ref({
      // eslint-disable-next-line
      current_page: 1,
      total: 0,
    });
    const page = ref(1);
    const sort = ref({ field: 'created_at', order: 'ASC' });
    const searchString = ref('');
    const searchStatus = ref('');

    const callGetLive = async () => {
      loading.value = true;
      activePollId.value = (await getLive(route.value.params.liveId)).active_poll_id;
    };
    const callGetVotes = async () => {
      loading.value = true;
      const { data, ...paginatorData } = await getVotes(
        page.value,
        30,
        sort.value,
        searchString.value,
      );
      votes.value = data.map((elm: any) => ({
        ...elm,
        _secondaryControls: false,
        _playPauseControls: elm.id !== activePollId.value,
      }));
      pagination.value = paginatorData;
      loading.value = false;
    };

    const pendingSearch = _.debounce(async () => {
      page.value = 1;
      await callGetVotes();
    }, 500);

    onMounted(async () => {
      await callGetLive();
      await callGetVotes();
      if (pusher) {
        const channel = pusher.subscribe(`session.${route.value.params.liveId}`);
        channel.bind('CrowdPollSubmitted', async (data: any) => {
          if (data.pollChoices[0].poll_id === activePollId.value) activePoll.value = await getVote(activePollId.value);
        });
      }
    });

    onUnmounted(() => {
      pusher.unsubscribe(`session.${route.value.params.liveId}`);
    });

    watch(() => page.value, async (newVal) => {
      // eslint-disable-next-line
      if (newVal !== pagination.value.current_page) {
        await callGetVotes();
      }
    });
    const handleSortChange = (sortParam: { field: string; order: string }) => {
      sort.value = sortParam;
    };
    watch(() => sort.value, async (newVal, oldVal) => {
      // eslint-disable-next-line
      if (newVal !== oldVal) {
        await callGetVotes();
      }
    });

    // ==================== //
    // Use with select item //
    const selectedItems: number[] = reactive([]);
    const selectItem = (id: number, status: boolean) => {
      if (status) {
        const removeIndex = selectedItems.findIndex((elm: any) => elm === id);
        if (removeIndex > -1) selectedItems.splice(removeIndex, 1);
      } else {
        selectedItems.push(id);
      }
      const index = votes.value.findIndex((elm: any) => elm.id === id);
      (votes.value[index] as any)._secondaryControls = !status;
    };
    const selectAllItems = () => {
      if (selectedItems.length > 0) selectedItems.splice(0, selectedItems.length);
      votes.value.forEach((elm: any, index: number) => {
        (votes.value[index] as any)._secondaryControls = true;
        selectedItems.push(elm.id);
      });
    };
    const unselectAllItems = () => {
      selectedItems.splice(0, selectedItems.length);
      votes.value.forEach((elm: any, index: number) => {
        (votes.value[index] as any)._secondaryControls = false;
      });
    };

    // =========================== //
    // Use with play pause control //
    const playPauseAction = async (id: number | null) => {
      let submitId: number | null = id;
      if (activePollId.value === id) {
        submitId = null;
      }
      activePollId.value = await controlVote(route.value.params.liveId, submitId as any);
      await callGetVotes();
      // votes.value.map((singleVote: any) => {
      //   if (singleVote.id !== latestActiveVoteId) {
      //     return {
      //       ...singleVote,
      //       _playPauseControls: false,
      //     };
      //   }
      //   return {
      //     ...singleVote,
      //     _playPauseControls: true,
      //   };
      // });
    };

    // Delete fn
    const deleteItemModal = ref(null);
    const deleteItemsModal = ref(null);
    const openDeleteItemModal = (item: any) => {
      (deleteItemModal.value as any).compose({
        id: item.id,
        action: 'ลบ',
        entity: 'กำหนดการ',
        body: `เป็นการลบ<br>${item.name}<br>จากระบบโดยถาวร<br>ไม่สามารถย้อนคืนได้`,
      });
    };
    const deleteItemAction = async (id: number) => {
      const result = await deleteVote(id);
      await callGetVotes();
    };
    const deleteItemsAction = async () => {
      const result = await deleteVotes(selectedItems);
      await callGetVotes();
    };

    async function downloadReport(voteId: number) {
      const result = await getVoteAsCSV(null, voteId, null);
      // console.log(result);
    }

    const singlePoll: Ref<any> = ref({
      id: -1,
      choices: [],
    });
    const modalWithVoteDisplay = ref(null);
    async function pendingToViewResult(voteId: number) {
      if (voteId === activePollId.value) {
        singlePoll.value = activePoll.value;
      } else {
        singlePoll.value = await getVote(voteId);
      }
      (modalWithVoteDisplay.value as any).open();
    }
    watch(() => activePollId.value, async (newVal, oldVal) => {
      if (newVal > -1 && newVal !== oldVal && newVal !== null) {
        activePoll.value = await getVote(activePollId.value);
      }
    });
    const totalSubmittedDisplayPoll = computed(() => {
      if (activePoll.value.id === -1) return 0;
      let result = 0;
      activePoll.value.choices.forEach((choice: any) => {
        result += choice.count;
      });
      if (result === 0) return 1;
      return result;
    });

    function getTotalPollAnswerInRecord(poll: any) {
      let result = 0;
      // eslint-disable-next-line
      poll.choices?.forEach((choice: any) => {
        result += choice.count;
      });
      return result;
    }

    return {
      votes,
      voteTableOptions: vote,
      activePollId,
      page,
      pagination,
      loading,
      searchString,
      searchStatus,

      pendingSearch,

      sort,
      handleSortChange,

      playPauseAction,

      selectItem,
      selectAllItems,
      selectedItems,
      unselectAllItems,

      openDeleteItemModal,
      deleteItemAction,
      deleteItemsAction,
      deleteItemModal,
      deleteItemsModal,

      downloadReport,

      singlePoll,
      activePoll,
      modalWithVoteDisplay,
      pendingToViewResult,
      totalSubmittedDisplayPoll,

      getTotalPollAnswerInRecord,
    };
  },
});

export default List;
